import * as React from 'react';
import { ProjectOverviewSection, ProjectOverviewSectionBullets, ProjectOverviewSectionTitle } from '../ProjectOverviewStyles';
import { language } from '../ProjectOverviewLanguage';
import { SubsectionLayout } from './Subsection';

export type Props = {
	section: any;
};

export const Section = (props: Props) => {
	const render = () => {
		const returnValue = (
			<ProjectOverviewSection>
				<ProjectOverviewSectionTitle>{props.section.title}</ProjectOverviewSectionTitle>
				<ProjectOverviewSectionBullets>{generateSubSections(props.section.subsections)}</ProjectOverviewSectionBullets>
			</ProjectOverviewSection>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};

export const generateSubSections = (subsections) => {
	const returnValue = subsections.map((subsection: any, index: number) => {
		const outgoingProps = {
			subsection,
		};
		const innerReturnValue = <SubsectionLayout {...outgoingProps} />;
		return innerReturnValue;
	});
	return returnValue;
};
